import * as z from "zod";
import { NodeResourceSchema } from "./compute-nodes.js";
export const WorkspaceDeletionManifestSchema = z
  .object({
    version: z.literal(1),
    spaceId: z.string(),
    userId: z.string(),
    workspaceGeneration: z.number().int().nonnegative(),
    nodes: z.array(NodeResourceSchema.extend({ operationId: z.string().uuid() })),
    botIds: z.array(z.string()),
    artifacts: z.array(z.object({ id: z.string(), storageKey: z.string() })),
    connections: z.array(
      z.object({
        id: z.string(),
        connectorId: z.string(),
        provider: z.string(),
        accountId: z.string().nullable(),
      }),
    ),
  })
  .strict();
export type WorkspaceDeletionManifest = z.infer<typeof WorkspaceDeletionManifestSchema>;
